// // import React, { useEffect, useState } from "react";
// // import { IoClose } from "react-icons/io5";
// // // import { AuthButton } from "../common/AuthButton";
// // import axios from "axios";
// // import toast from "react-hot-toast";
// // import { useAuthStore } from "../../context/useAuthStore";

// // interface CollegeWiseStudentDataModalProps {
// //   collegeName: string;
// //   onClose: () => void;
// // }

// // type SubscriptionInfo = {
// //   subjectName: string;
// //   subscriptionId: string;
// // };

// // type StudentData = {
// //   fullName: string;
// //   phoneNumber: string;
// //   emailId?: string;
// //   college?: string;
// //   roleId?: string;
// //   userId: string;
// //   verifiedSubscriptionsList?: SubscriptionInfo[];
// // };

// // const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// // const CollegeWiseStudentDataModal: React.FC<
// //   CollegeWiseStudentDataModalProps
// // > = ({ collegeName, onClose }) => {
// //   const { user, token } = useAuthStore();
// //   const [students, setStudents] = useState<StudentData[]>([]); // Changed to array
// //   const [loading, setLoading] = useState(false);

// //   useEffect(() => {
// //     let isMounted = true;

// //     const fetchStudentData = async () => {
// //       if (!token) {
// //         toast.error("Authentication token not found.");
// //         setLoading(false);
// //         return;
// //       }

// //       setLoading(true);
// //       try {
// //         // Fixed: Added proper endpoint or removed userId parameter if not needed
// //         const res = await axios.get<{ status: string; success: StudentData[] }>(
// //           `${API_BASE_URL}/user?userId=`,
// //           {
// //             headers: {
// //               "Content-Type": "application/json",
// //               Authorization: `Bearer ${token}`,
// //             },
// //             withCredentials: true,
// //           }
// //         );

// //         const allStudents: StudentData[] = res.data.success || [];
// //         const filteredStudents = allStudents.filter(
// //           (u) => (u.college ?? "").toLowerCase() === collegeName.toLowerCase()
// //         );

// //         // Fetch subscription data for each filtered student
// //         const studentsWithSubjects = await Promise.all(
// //           filteredStudents.map(async (student) => {
// //             try {
// //               const subRes = await axios.get(
// //                 `${API_BASE_URL}/subscription?userId=${student.userId}`,
// //                 {
// //                   headers: {
// //                     "Content-Type": "application/json",
// //                     Authorization: `Bearer ${token}`,
// //                   },
// //                   withCredentials: true,
// //                 }
// //               );

// //               const subscriptions = subRes.data?.success || [];

// //               const verifiedSubjectsList: SubscriptionInfo[] = subscriptions
// //                 .filter((s: any) => s?.status === "Subscribed")
// //                 .map((s: any) => ({
// //                   subjectName: s.subjectName,
// //                   subscriptionId: s.subscriptionId,
// //                 }));

// //               return {
// //                 ...student,
// //                 verifiedSubscriptionsList: verifiedSubjectsList,
// //               };
// //             } catch (error) {
// //               console.error(
// //                 `Failed to fetch subscriptions for user ${student.userId}:`,
// //                 error
// //               );
// //               return {
// //                 ...student,
// //                 verifiedSubscriptionsList: [],
// //               };
// //             }
// //           })
// //         );

// //         if (isMounted) {
// //           setStudents(studentsWithSubjects);
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch dashboard data:", error);
// //         toast.error("Failed to fetch student data.");
// //       } finally {
// //         if (isMounted) setLoading(false);
// //       }
// //     };

// //     fetchStudentData();

// //     return () => {
// //       isMounted = false;
// //     };
// //   }, [collegeName, token, user?.userId]);

// //   if (loading) {
// //     return (
// //       <section
// //         className="modalSection"
// //         role="dialog"
// //         aria-modal="true"
// //         aria-labelledby="student-subject-modal"
// //       >
// //         <div className="modalContainer">
// //           <div className="flex justify-center items-center p-8">
// //             <div className="text-center">
// //               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-600 mx-auto"></div>
// //               <p className="mt-2 text-sm text-gray-600">
// //                 Loading student data...
// //               </p>
// //             </div>
// //           </div>
// //         </div>
// //       </section>
// //     );
// //   }

// //   return (
// //     <section
// //       className="modalSection"
// //       role="dialog"
// //       aria-modal="true"
// //       aria-labelledby="student-subject-modal"
// //     >
// //       <div className="modalContainer">
// //         {/* Modal Header */}
// //         <div className="flex justify-between items-center gap-2 border-b pb-1 border-gray-200">
// //           <h2 id="student-subject-modal" className="text-base font-semibold">
// //             {collegeName} - Students ({students.length})
// //           </h2>
// //           <button
// //             onClick={onClose}
// //             className="modalCloseButton"
// //             aria-label="Close modal"
// //           >
// //             <IoClose size={20} />
// //           </button>
// //         </div>

// //         {/* Student Info */}
// //         <div className="logoutModalBody text-left">
// //           {students.length === 0 ? (
// //             <div className="text-center py-8">
// //               <p className="text-gray-500">
// //                 No students found for this college.
// //               </p>
// //             </div>
// //           ) : (
// //             <div className="overflow-x-auto border rounded-md">
// //               <table className="min-w-full border-collapse">
// //                 <thead className="sticky top-0 bg-white z-10">
// //                   <tr className="tableHeadRow">
// //                     <th className="tableHeadValue">Student Name</th>
// //                     <th className="tableHeadValue">Phone Number</th>
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {students.map((student) => (
// //                     <tr className="tableBodyRow" key={student.userId}>
// //                       <td className="tableBodyValue">{student.fullName}</td>
// //                       <td className="tableBodyValue">{student.phoneNumber}</td>
// //                     </tr>
// //                   ))}
// //                 </tbody>
// //               </table>
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default CollegeWiseStudentDataModal;
// import React, { useEffect, useState } from "react";
// import { IoClose } from "react-icons/io5";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { useAuthStore } from "../../context/useAuthStore";
// import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";

// interface CollegeWiseStudentDataModalProps {
//   collegeName: string;
//   onClose: () => void;
// }

// type SubscriptionInfo = {
//   subjectName: string;
//   subscriptionId: string;
// };

// type StudentData = {
//   fullName: string;
//   phoneNumber: string;
//   emailId?: string;
//   college?: string;
//   roleId?: string;
//   userId: string;
//   verifiedSubscriptionsList?: SubscriptionInfo[];
// };

// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
// const phoneUtil = PhoneNumberUtil.getInstance();

// const CollegeWiseStudentDataModal: React.FC<
//   CollegeWiseStudentDataModalProps
// > = ({ collegeName, onClose }) => {
//   const { user, token } = useAuthStore();
//   const [students, setStudents] = useState<StudentData[]>([]);
//   const [loading, setLoading] = useState(false);

//   const formatPhoneNumber = (number: string, region = "IN") => {
//     try {
//       const phoneNumber = phoneUtil.parseAndKeepRawInput(number, region);
//       const isValidNumber = phoneUtil.isValidNumber(phoneNumber);
//       let formatted = phoneUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
//       if (formatted.startsWith("0")) {
//         formatted = formatted.substring(1);
//       }
//       return { formatted, isValidNumber };
//     } catch {
//       return { formatted: number, isValidNumber: false };
//     }
//   };

//   useEffect(() => {
//     let isMounted = true;

//     const fetchStudentData = async () => {
//       if (!token) {
//         toast.error("Authentication token not found.");
//         setLoading(false);
//         return;
//       }

//       setLoading(true);
//       try {
//         const res = await axios.get<{ status: string; success: StudentData[] }>(
//           `${API_BASE_URL}/user`,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             withCredentials: true,
//           }
//         );

//         const allStudents: StudentData[] = res.data.success || [];
//         const filteredStudents = allStudents.filter(
//           (u) => (u.college ?? "").toLowerCase() === collegeName.toLowerCase()
//         );

//         // Fetch subscription data for each filtered student
//         const studentsWithSubjects = await Promise.all(
//           filteredStudents.map(async (student) => {
//             try {
//               const subRes = await axios.get(
//                 `${API_BASE_URL}/subscription?userId=${student.userId}`,
//                 {
//                   headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${token}`,
//                   },
//                   withCredentials: true,
//                 }
//               );

//               const subscriptions = subRes.data?.success || [];

//               const verifiedSubjectsList: SubscriptionInfo[] = subscriptions
//                 .filter((s: any) => s?.status === "Subscribed")
//                 .map((s: any) => ({
//                   subjectName: s.subjectName,
//                   subscriptionId: s.subscriptionId,
//                 }));

//               return {
//                 ...student,
//                 verifiedSubscriptionsList: verifiedSubjectsList,
//               };
//             } catch (error) {
//               console.error(
//                 `Failed to fetch subscriptions for user ${student.userId}:`,
//                 error
//               );
//               return {
//                 ...student,
//                 verifiedSubscriptionsList: [],
//               };
//             }
//           })
//         );

//         if (isMounted) {
//           setStudents(studentsWithSubjects);
//         }
//       } catch (error) {
//         console.error("Failed to fetch dashboard data:", error);
//         toast.error("Failed to fetch student data.");
//       } finally {
//         if (isMounted) setLoading(false);
//       }
//     };

//     fetchStudentData();

//     return () => {
//       isMounted = false;
//     };
//   }, [collegeName, token, user?.userId]);

//   if (loading) {
//     return (
//       <section
//         className="modalSection"
//         role="dialog"
//         aria-modal="true"
//         aria-labelledby="student-subject-modal"
//       >
//         <div className="modalContainer">
//           <div className="flex justify-center items-center p-8">
//             <div className="text-center">
//               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-600 mx-auto"></div>
//               <p className="mt-2 text-sm text-gray-600">
//                 Loading student data...
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section
//       className="modalSection"
//       role="dialog"
//       aria-modal="true"
//       aria-labelledby="student-subject-modal"
//     >
//       <div className="modalContainer">
//         {/* Modal Header */}
//         <div className="flex justify-between items-center gap-2 border-b pb-1 border-gray-200">
//           <h2 id="student-subject-modal" className="text-base font-semibold">
//             {collegeName} - ({students.length} Students)
//           </h2>
//           <button
//             onClick={onClose}
//             className="modalCloseButton"
//             aria-label="Close modal"
//           >
//             <IoClose size={20} />
//           </button>
//         </div>

//         {/* Student Info */}
//         <div className="logoutModalBody text-left">
//           {students.length === 0 ? (
//             <div className="text-center py-8">
//               <p className="text-gray-500">
//                 No students found for this college.
//               </p>
//             </div>
//           ) : (
//             <div className="overflow-x-auto border rounded-md max-h-[calc(100vh-20rem)] overflow-y-auto">
//               <table className="min-w-full border-collapse">
//                 <thead className="sticky top-0 bg-white z-10">
//                   <tr className="tableHeadRow">
//                     <th className="tableHeadValue">Student Name</th>
//                     <th className="tableHeadValue">Phone Number</th>
//                     <th className="tableHeadValue">Subscribed Subjects</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {students.map((student) => {
//                     const { formatted, isValidNumber } = formatPhoneNumber(
//                       student.phoneNumber
//                     );
//                     const subscribedCount =
//                       student.verifiedSubscriptionsList?.length || 0;

//                     return (
//                       <tr className="tableBodyRow" key={student.userId}>
//                         <td className="tableBodyValue">{student.fullName}</td>
//                         <td
//                           className={`tableBodyValue ${
//                             !isValidNumber ? "underline text-red-600" : ""
//                           }`}
//                         >
//                           {formatted}
//                         </td>
//                         <td className="tableBodyValue">
//                           <span
//                             className={`inline-flex items-center rounded-md px-3 py-1 text-sm font-medium ring-1 ring-inset
//                               ${
//                                 subscribedCount > 0
//                                   ? "bg-gray-50 text-gray-600 ring-gray-500/10"
//                                   : "bg-red-50 text-red-600 ring-red-500/10"
//                               }`}
//                           >
//                             {subscribedCount || 0}
//                           </span>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CollegeWiseStudentDataModal;
import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { FaFileExcel as ExcelIcon } from "react-icons/fa";
import axios from "axios";
import toast from "react-hot-toast";
import { useAuthStore } from "../../context/useAuthStore";
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

interface CollegeWiseStudentDataModalProps {
  collegeName: string;
  onClose: () => void;
}

type SubscriptionInfo = {
  subjectName: string;
  subscriptionId: string;
};

type StudentData = {
  fullName: string;
  phoneNumber: string;
  emailId?: string;
  college?: string;
  roleId?: string;
  userId: string;
  verifiedSubscriptionsList?: SubscriptionInfo[];
};

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const phoneUtil = PhoneNumberUtil.getInstance();

const CollegeWiseStudentDataModal: React.FC<
  CollegeWiseStudentDataModalProps
> = ({ collegeName, onClose }) => {
  const { user, token } = useAuthStore();
  const [students, setStudents] = useState<StudentData[]>([]);
  const [loading, setLoading] = useState(false);

  const formatPhoneNumber = (number: string, region = "IN") => {
    try {
      const phoneNumber = phoneUtil.parseAndKeepRawInput(number, region);
      const isValidNumber = phoneUtil.isValidNumber(phoneNumber);
      let formatted = phoneUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
      if (formatted.startsWith("0")) {
        formatted = formatted.substring(1);
      }
      return { formatted, isValidNumber };
    } catch {
      return { formatted: number, isValidNumber: false };
    }
  };

  const exportToExcel = () => {
    if (students.length === 0) {
      toast.error("No student data to export");
      return;
    }

    // Prepare data for Excel
    const data = students.map((student, index) => {
      const subscribedSubjects =
        student.verifiedSubscriptionsList
          ?.map((s) => s.subjectName)
          .join(", ") || "None";

      return {
        "Sl.No": index + 1,
        "Student Name": student.fullName,
        "Phone Number": formatPhoneNumber(student.phoneNumber).formatted,
        "Email ID": student.emailId || "N/A",
        College: student.college || collegeName,
        "Subscribed Subjects Count":
          student.verifiedSubscriptionsList?.length || 0,
        "Subscribed Subjects List": subscribedSubjects,
      };
    });

    const worksheetName = `${collegeName} Students`.substring(0, 31);

    // Create worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${worksheetName}`);

    // Generate Excel file buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Create a blob and trigger download
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const fileName = `${collegeName}.xlsx`;
    saveAs(blob, fileName);

    toast.success(`Exported ${students.length} students to Excel`);
  };

  useEffect(() => {
    let isMounted = true;

    const fetchStudentData = async () => {
      if (!token) {
        toast.error("Authentication token not found.");
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const res = await axios.get<{ status: string; success: StudentData[] }>(
          `${API_BASE_URL}/user`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          }
        );

        const allStudents: StudentData[] = res.data.success || [];
        const filteredStudents = allStudents.filter(
          (u) => (u.college ?? "").toLowerCase() === collegeName.toLowerCase()
        );

        // Fetch subscription data for each filtered student
        const studentsWithSubjects = await Promise.all(
          filteredStudents.map(async (student) => {
            try {
              const subRes = await axios.get(
                `${API_BASE_URL}/subscription?userId=${student.userId}`,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  withCredentials: true,
                }
              );

              const subscriptions = subRes.data?.success || [];

              const verifiedSubjectsList: SubscriptionInfo[] = subscriptions
                .filter((s: any) => s?.status === "Subscribed")
                .map((s: any) => ({
                  subjectName: s.subjectName,
                  subscriptionId: s.subscriptionId,
                }));

              return {
                ...student,
                verifiedSubscriptionsList: verifiedSubjectsList,
              };
            } catch (error) {
              console.error(
                `Failed to fetch subscriptions for user ${student.userId}:`,
                error
              );
              return {
                ...student,
                verifiedSubscriptionsList: [],
              };
            }
          })
        );

        if (isMounted) {
          setStudents(studentsWithSubjects);
        }
      } catch (error) {
        console.error("Failed to fetch dashboard data:", error);
        toast.error("Failed to fetch student data.");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchStudentData();

    return () => {
      isMounted = false;
    };
  }, [collegeName, token, user?.userId]);

  if (loading) {
    return (
      <section
        className="modalSection"
        role="dialog"
        aria-modal="true"
        aria-labelledby="student-subject-modal"
      >
        <div className="modalContainer">
          <div className="flex justify-center items-center p-8">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-600 mx-auto"></div>
              <p className="mt-2 text-sm text-gray-600">
                Loading student data...
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      className="modalSection"
      role="dialog"
      aria-modal="true"
      aria-labelledby="student-subject-modal"
    >
      <div className="modalContainer">
        {/* Modal Header */}
        <div className="flex justify-between items-center gap-2 border-b pb-1 border-gray-200">
          <h2 id="student-subject-modal" className="text-base font-semibold">
            {collegeName} - ({students.length} Students)
          </h2>
          <div className="flex items-center gap-2">
            {students.length > 0 && (
              <button
                onClick={exportToExcel}
                className="flex items-center gap-1 px-3 py-1.5 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
                aria-label="Export to Excel"
                title="Export to Excel"
              >
                <ExcelIcon size={14} />
                <span className="hidden sm:inline">Export</span>
              </button>
            )}
            <button
              onClick={onClose}
              className="modalCloseButton"
              aria-label="Close modal"
            >
              <IoClose size={20} />
            </button>
          </div>
        </div>

        {/* Student Info */}
        <div className="logoutModalBody text-left">
          {students.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-gray-500">
                No students found for this college.
              </p>
            </div>
          ) : (
            <>
              <div className="mb-4 text-sm text-gray-600">
                <p>Total students: {students.length}</p>
                <p>
                  Click the Export button to download this data as Excel file.
                </p>
              </div>
              <div className="overflow-x-auto border rounded-md max-h-[calc(100vh-20rem)] overflow-y-auto">
                <table className="min-w-full border-collapse">
                  <thead className="sticky top-0 bg-white z-10">
                    <tr className="tableHeadRow">
                      <th className="tableHeadValue">Student Name</th>
                      <th className="tableHeadValue">Phone Number</th>
                      <th className="tableHeadValue">Subscribed Subjects</th>
                    </tr>
                  </thead>
                  <tbody>
                    {students.map((student) => {
                      const { formatted, isValidNumber } = formatPhoneNumber(
                        student.phoneNumber
                      );
                      const subscribedCount =
                        student.verifiedSubscriptionsList?.length || 0;

                      return (
                        <tr className="tableBodyRow" key={student.userId}>
                          <td className="tableBodyValue">{student.fullName}</td>
                          <td
                            className={`tableBodyValue ${
                              !isValidNumber ? "underline text-red-600" : ""
                            }`}
                          >
                            {formatted}
                          </td>
                          <td className="tableBodyValue">
                            <span
                              className={`inline-flex items-center rounded-md px-3 py-1 text-sm font-medium ring-1 ring-inset
                                ${
                                  subscribedCount > 0
                                    ? "bg-gray-50 text-gray-600 ring-gray-500/10"
                                    : "bg-red-50 text-red-600 ring-red-500/10"
                                }`}
                            >
                              {subscribedCount || 0}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default CollegeWiseStudentDataModal;
